'use strict';

let _ = require('lodash');

let AttributeConstraintValues = require('./../../Attribute/Collection/Values/index');
let AttributeConstraintRanges = require('./../../Attribute/Collection/Ranges/index');
let AttributeConstraintFormula = require('./../../Attribute/Collection/Formula/index');
let Factory = require('./../index');
let Range = require('../../NumericValues/Range');
let RuleConstraintValues = require('./../../Attribute/Collection/Values/Rule/index');
let RuleConstraintRanges = require('./../../Attribute/Collection/Ranges/Rule/index');
let RuleFormula = require('./../../Attribute/Collection/Formula/Rule/index');

class AttributeFactory extends Factory {
    /**
     * Creates a valid attribute given the configuration
     * @param  {Object} config The configuration object to use. See the Attribute class for details.
     * @return {Object}        An attribute class object.
     */
    static create(config) {
        Factory._validate(config);

        if (isListOfValues(config)) {
            if (_.isNil(config.negate)) {
                return new AttributeConstraintValues(config);
            }
            return new RuleConstraintValues(config);
        }

        if (isListOfRanges(config)) {
            config.attributeRanges = buildRanges(config);
            if (_.isNil(config.negate)) {
                return new AttributeConstraintRanges(config);
            }
            return new RuleConstraintRanges(config);
        }

        if (isFormula(config)) {
            // This is the case when the formula is in a container value
            if (_.isNil(config.negate)) {
                return new AttributeConstraintFormula(config);
            }
            // This is the case when the forumula is in a rule
            return new RuleFormula(config);
        }

        throw new Error('Not Implemented');
    }
}

module.exports = AttributeFactory;

function isListOfValues(config) {
    return !_.isNil(config.attributeValues) && _.isNil(config.attributeRanges) && _.isNil(config.formula);
}

function isListOfRanges(config) {
    return _.isNil(config.attributeValues) && !_.isNil(config.attributeRanges) && _.isNil(config.formula);
}

function isFormula(config) {
    return !_.isNil(config.formula) && _.isNil(config.attributeValues) && _.isNil(config.attributeRanges);
}

function buildRanges(config) {
    return _.map(config.attributeRanges, (rangeConfig) => {
        /**
         * Imply the range's increment when the range is bound to a single value (min === max).
         * This is necessary for consistent range handling since AttributeConstraintRanges.validOptions() implies
         * the range's increment when an attribute has one valid range that is bound to a single value.
         */
        if (rangeConfig.minimum === rangeConfig.maximum) {
            rangeConfig.increment = rangeConfig.minimum;
        }

        return new Range(rangeConfig.minimum, rangeConfig.maximum, rangeConfig.increment, rangeConfig.unitOfMeasure);
    });
}
